<template>
  <div v-if="permissoes.editar_avisos">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Avisos</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Registro de Avisos</h1>
      </el-col>
    </el-row>
    <el-row type="flex" justify="left">
      <el-col :span="1">
        <!-- <h1> <el-button type="primary" @click="handleAdd()" round>Novo</el-button></h1> -->
        <h1>
          <el-button
            type="primary"
            v-if="permissoes.editar_avisos"
            @click="dialogFormVisible = true"
            icon="el-icon-circle-plus-outline"
          >Novo</el-button>
        </h1>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="itens"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)" >
          <el-table-column prop="titulo" label="Título" min-width="250"></el-table-column>
          <el-table-column prop="show" v-if="permissoes.editar_avisos" label="Mostrar" width="75">
            <template slot-scope="scope">
              <el-switch v-on:change="handleMostra(scope.row)" v-model="scope.row.mostra"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="acao" label="Ação" filter-placement="bottom-end" width="185">
            <template slot-scope="scope">
              <el-button
                v-if="permissoes.editar_avisos"
                size="mini"
                type="primary"
                icon="el-icon-edit"
                @click="handleEdit(scope.$index, scope.row)"
              >Edit</el-button>
              <el-button
                v-if="permissoes.excluir_avisos"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row)"
              >Delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <!-- DIALOG DE CADASTRO DE AVISOS -->
    <el-dialog title="Novo Aviso" :visible="dialogFormVisible" :show-close="false">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
        <el-form-item label="Título" prop="titulo">
          <el-input v-model="ruleForm.titulo"></el-input>
        </el-form-item>
        <el-form-item label="Aviso" prop="descricao">
          <el-input type="textarea" autosize maxlength="440" show-word-limit v-model="ruleForm.descricao"></el-input>
        </el-form-item>
        <el-form-item label="Mostrar Aviso?" prop="show" style="text-align:left">
          <el-switch v-model="ruleForm.show"></el-switch>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFechar()">Cancelar</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>

    <!-- DIALOG DE EDIÇÃO DE AVISOS -->
    <el-dialog title="Editar Aviso" :visible="dialogFormVisibleEdit" :show-close="false">
      <el-form
        :model="ruleFormEdit"
        :rules="rules"
        ref="ruleFormEdit"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
        <el-form-item label="Id" prop="id">
          <el-input v-model="ruleFormEdit.id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="Título" prop="titulo">
          <el-input v-model="ruleFormEdit.titulo"></el-input>
        </el-form-item>
        <el-form-item label="Aviso" prop="descricao">
          <el-input type="textarea" autosize maxlength="440" show-word-limit v-model="ruleFormEdit.descricao"></el-input>
        </el-form-item>
        <el-form-item label="Mostrar Aviso?" prop="show" style="text-align:left">
          <el-switch v-model="ruleFormEdit.show"></el-switch>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFecharEdit()">Cancelar</el-button>
        <el-button type="primary" @click="submitFormEdit('ruleFormEdit')">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style>
.el-row-topo {
  margin-top: 10px;
}
</style>

<script>
import axios from "axios";
import FuncoesUteis from "../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      files: [],
      loading: true,
      falso: false,
      verdadeiro: true,
      labelPosition: "right",
      itens: [],
      permissoes: {},
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      ruleForm: {
        titulo: "",
        descricao: "",
        show: true, //1
      },
      ruleFormEdit: {
        titulo: "",
        descricao: "",
        id: "",
        show: false, //0
      },
      rules: {
        titulo: [
          {
            required: true,
            message: "Por Favor, informe o Título",
            trigger: "blur",
          },
          {
            min: 3,
            message: "Deve ter pelo menos 3 caracteres",
            trigger: "blur",
          },
        ],
        descricao: [
          { required: true, message: "Informe a Descrição", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.permissoes = FuncoesUteis.isPermissao();
    if (!this.permissoes.ler_avisos) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.loading = true;
    axios
      .get(url + "/avisos/", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        this.itens = response.data;
        this.loading = false;
        for (var i = 0; i < this.itens.length; i++) {
          if (this.itens[i].mostra == 1) {
            this.itens[i].mostra = true;
          } else {
            this.itens[i].mostra = false;
          }
        }
      })
      .catch((err) => {
        this.itens = "erro" + err;
      });
  },
  methods: {
    getDados() {
      this.loading = true;
      axios
        .get(url + "/avisos/", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.itens = response.data;
          this.loading = false;
          for (var i = 0; i < this.itens.length; i++) {
            if (this.itens[i].mostra == 1) {
              this.itens[i].mostra = true;
            } else {
              this.itens[i].mostra = false;
            }
          }
        })
        .catch((err) => {
          this.itens = "erro" + err;
        });
    },
    handleEdit(index, row) {
      this.dialogFormVisibleEdit = true;
      this.ruleFormEdit.titulo = row.titulo;
      this.ruleFormEdit.descricao = row.descricao;
      this.ruleFormEdit.id = row.id;
      this.ruleFormEdit.show = row.mostra;
    },
    handleMostra(row) {
      let dados = {
        show: row.mostra,
      };
      axios
        .put(url + "/avisos/" + row.id, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then(() => {
          this.$notify({
            title: "Sucesso",
            message: "Registro Alterado com sucesso!",
            type: "success",
          });
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao alterar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });
    },
    handleFecharEdit() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisibleEdit = false;
        })
        .catch(() => {
          this.dialogFormVisibleEdit = true;
        });
    },
    handleFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisible = false;
          this.ruleForm.titulo = "";
          this.ruleForm.descricao = "";
          this.files = [];
        })
        .catch(() => {
          this.dialogFormVisible = true;
        });
    },
    handleDelete(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/avisos/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDados();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dados = {
            titulo: this.ruleForm.titulo,
            descricao: this.ruleForm.descricao,
            show: this.ruleForm.show,
          };
          axios
            .post(url + "/avisosreg/", dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Salvo com sucesso!",
                type: "success",
              });
              this.dialogFormVisible = false;
              this.ruleForm.titulo = "";
              this.ruleForm.descricao = "";
              this.getDados();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });
              this.dialogFormVisible = false;
              this.ruleForm.titulo = "";
              this.ruleForm.descricao = "";
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    submitFormEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dados = {
            titulo: this.ruleFormEdit.titulo,
            descricao: this.ruleFormEdit.descricao,
            show: this.ruleFormEdit.show,
          };
          let id = this.ruleFormEdit.id;

          axios
            .put(url + "/avisos/" + id, dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Alterado com sucesso!",
                type: "success",
              });
              this.dialogFormVisibleEdit = false;
              this.ruleFormEdit.titulo = "";
              this.ruleFormEdit.descricao = "";
              this.getDados();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao alterar os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
              this.dialogFormVisibleEdit = false;
              this.ruleFormEdit.titulo = "";
              this.ruleFormEdit.descricao = "";
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    handleFiles() {
      let uploadedFiles = this.$refs.files.files;

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
      this.getImagePreviews();
    },
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function () {
              this.$refs["preview" + parseInt(i)][0].src = reader.result;
            }.bind(this),
            false
          );
          reader.readAsDataURL(this.files[i]);
        } else {
          this.$nextTick(function () {
            this.$refs["preview" + parseInt(i)][0].src = "/img/generic.png";
          });
        }
      }
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews();
    },
    submitFiles() {
      let dados = "";
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          dados = {
            titulo: this.ruleForm.titulo,
            descricao: this.ruleForm.descricao,
            show: this.ruleForm.show,
          };
          //let formData = new FormData();
          dados.append("image", this.files);
        }
      });
      axios
        .post(url + "/avisosreg", dados, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then(
          function (data) {
            //this.files[i].id = data['data']['id'];
            //this.files.splice(i, 1, this.files[i]);
            console.log("success" + data);
          }.bind(this)
        )
        .catch(function (data) {
          console.log("error" + data);
        });
    },
  },
};
</script>